const nopage = () => {
    return ( 
        <p>Page Not Found</p>
     );
}
 
export default nopage;